import { Button, Modal } from "antd";
import React from "react";

const ShowModalComfirmSubmit = ({
  isCheckShowModalConfirm,
  handleSubmitExam,
  handleOnCancel,
}) => {
  return (
    <Modal
      title="Xác nhận nộp bài"
      open={isCheckShowModalConfirm}
      footer={false}
      closable={false}
      centered
      bodyStyle={{ textAlign: "center", paddingBottom: 30 }}
    >
      <p>Bạn chắc chắn muốn nộp bài?</p>
      <div style={{ display: "flex", justifyContent: "center", gap: 10 }}>
        <Button onClick={handleOnCancel}>Huỷ</Button>
        <Button type="primary" onClick={handleSubmitExam}>
          Nộp bài
        </Button>
      </div>
    </Modal>
  );
};

export default ShowModalComfirmSubmit;
